<template>
  <div 
    class="conditions-section mb-4"
    :class="{'offer-rejected': rejected}"
  >
    <h6 class="section-title mb-3">
      <i class="fa fa-list-alt mr-2" />
      {{ $t('detailedComparisonModal.requiredConditions') || 'Tələb olunan şərtlər' }}
    </h6>
    <div class="row g-3">
      <div
        v-for="(item, index) in conditionItems"
        :key="index"
        :class="`col-md-${item.md || 2} mb-3`"
      >
        <div class="condition-card h-100 d-flex flex-column align-items-center p-3 rounded">
          <div class="icon-circle mb-2">
            <i :class="`fa ${item.icon}`" />
          </div>
          <div class="condition-label">
            {{ item.label }}
          </div>
          <div class="condition-value mt-1">
            {{ item.value || '-' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getPaymentOptionLabel} from "@/repositories/GeneralDataRepository";

export default {
  name: "RequiredConditionsSection",
  props: {
    priceExtras: {
      type: Object,
      required: true
    },
    rejected: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    conditionItems() {
      return [
        { 
          icon: 'fa-truck', 
          label: this.$t('detailedComparisonModal.catdirilma'), 
          value: this.priceExtras.incoterms 
        },
        { 
          icon: 'fa-clock-o', 
          label: this.$t('detailedComparisonModal.catdirilma2'), 
          value: (this.priceExtras.deliveryDays ?? '') + ' ' + this.$t('detailedComparisonModal.day') 
        },
        { 
          icon: 'fa-files-o', 
          label: this.$t('detailedComparisonModal.paymentOption'), 
          value: this.getPaymentOptionLabel(this.priceExtras.paymentOption) + ' ' + (this.priceExtras.paymentComment ?? ''), 
          md: 3 
        },
        { 
          icon: 'fa-shield', 
          label: this.$t('detailedComparisonModal.warrantyPeriod'), 
          value: (this.priceExtras.warrantyPeriod ?? '') + ' ' + this.$t('detailedComparisonModal.month') + ' ' + (this.priceExtras.warrantyComment ?? ''), 
          md: 3 
        },
        { 
          icon: 'fa-globe', 
          label: this.$t('detailedComparisonModal.manufacturerCountry'), 
          value: this.priceExtras.manufacturerCountry 
        }
      ];
    }
  },
  methods: {
    getPaymentOptionLabel
  }
};
</script>

<style scoped>
/* Conditions Section */
.conditions-section {
  background-color: #ffffff;
}

.section-title {
  color: #495057;
  font-weight: 600;
  margin-bottom: 1rem;
}

.condition-card {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  transition: all 0.2s ease;
}

.condition-card:hover {
  background-color: #f1f3f5;
  transform: translateY(-2px);
}

.icon-circle {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: #e7f5ff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #007bff;
  font-size: 1.25rem;
}

.condition-label {
  font-size: 0.85rem;
  color: #6c757d;
  font-weight: 600;
}

.condition-value {
  font-size: 1rem;
  font-weight: 600;
  color: #343a40;
}

.offer-rejected {
  background-color: #f9f9f9;
  opacity: 0.75;
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .condition-card {
    margin-bottom: 1rem;
  }
}
</style>
